import { render } from "./Data4.vue?vue&type=template&id=1acbaf62"
import script from "./Data4.vue?vue&type=script&lang=js"
export * from "./Data4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__